export default __webpack_public_path__ + "static/media/grid4.81e40891.png";